import { styled } from '@linaria/react';

export const ProductItemWrapper = styled.div`
  height: 100%;
  position: relative;
`;

export const ClickBlocker = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 2;
  cursor: pointer;
`;
